import { useEffect, useState } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";
import { normalizeTier } from "@/utils/planMessaging";

const REPORT_PLAN_TEXT = {
  free: "PDF reports require Starter or Pro.",
  starter: "5 PDF reports/month",
  pro: "Unlimited PDF reports",
  developer: "Unlimited PDF reports",
};

export const useReportQuota = (enabled = true) => {
  const { token, user } = useAuth();
  const [usageLimits, setUsageLimits] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !token || !user) return;
    let cancelled = false;

    const loadUsageLimits = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API}/auth/usage-limits`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) setUsageLimits(response.data);
      } catch (_error) {
        if (!cancelled) setUsageLimits(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadUsageLimits();
    return () => {
      cancelled = true;
    };
  }, [enabled, token, user]);

  const normalizedTier = normalizeTier(user?.tier);
  const reportsUsedThisMonth = usageLimits?.usage?.reports_this_month ?? 0;
  const reportMonthlyLimit = usageLimits?.limits?.max_reports_per_month;
  const isStarter = normalizedTier === "starter";
  const isFree = normalizedTier === "free";
  const isProLike = normalizedTier === "pro" || normalizedTier === "developer";
  const starterLimitReached =
    isStarter &&
    Number.isFinite(reportMonthlyLimit) &&
    reportsUsedThisMonth >= reportMonthlyLimit;

  return {
    usageLimits,
    loading,
    reportsUsedThisMonth,
    reportMonthlyLimit,
    isStarter,
    isFree,
    isProLike,
    starterLimitReached,
    reportPlanText: REPORT_PLAN_TEXT[normalizedTier] || REPORT_PLAN_TEXT.free,
  };
};

